import React,{useState} from 'react';
import s from './Servicos.module.css';
import {Btn} from '../UI/Btn';
import {Modal} from '../UI/Modal';
import {Field,Inp} from '../UI/Inp';
import {Icons} from '../Sidebar/Icons';
import {useStore} from '../../hooks/useStore';
import {store} from '../../utils/store';
import {fmtMoeda,moedaToNum,fmtDur} from '../../utils/helpers';

const fmtP=v=>Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});

function SvcModal({initial,onClose}){
  const isEdit=!!initial?.id;
  const [nome,setNome]=useState(initial?.nome||'');
  const [preco,setPreco]=useState(initial?.preco?fmtMoeda(String(Math.round(Number(initial.preco)*100))):'');
  const [dur,setDur]=useState(String(initial?.dur||''));
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);

  const handleSave=async()=>{
    setErr('');
    if(!nome.trim()){setErr('Informe o nome.');return;}
    const p=moedaToNum(preco);
    if(!preco||p<=0){setErr('Informe um preço válido.');return;}
    if(!dur||Number(dur)<=0){setErr('Informe a duração.');return;}
    setLoading(true);
    try{
      if(isEdit) await store.updateServico(initial.id,{nome:nome.trim(),preco:p,dur:Number(dur)});
      else await store.addServico({nome:nome.trim(),preco:p,dur:Number(dur)});
      onClose();
    }catch(e){setErr(e.message);}
    finally{setLoading(false);}
  };

  return(
    <Modal title={isEdit?'Editar Serviço':'Novo Serviço'} onClose={onClose}
      footer={<><Btn variant="secondary" onClick={onClose}>Cancelar</Btn><Btn onClick={handleSave} disabled={loading}>{loading?'Salvando...':isEdit?'Salvar':'Cadastrar'}</Btn></>}
      maxWidth={420}>
      {err&&<div style={{background:'var(--red-l)',color:'var(--red)',border:'0.5px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>⚠️ {err}</div>}
      <Field label="Nome do Serviço" required>
        <Inp value={nome} onChange={e=>setNome(e.target.value)} placeholder="Ex: Manicure"/>
      </Field>
      <Field label="Preço" required hint="ex: R$ 50,00">
        <Inp value={preco} onChange={e=>setPreco(fmtMoeda(e.target.value))} placeholder="R$ 0,00" inputMode="numeric"/>
        {preco&&<div style={{marginTop:6,fontSize:13,fontWeight:600,color:'var(--green)',background:'var(--green-l)',padding:'5px 10px',borderRadius:6,display:'inline-block'}}>{fmtP(moedaToNum(preco))}</div>}
      </Field>
      <Field label="Duração" required hint="em minutos">
        <div style={{display:'flex',gap:10,alignItems:'center'}}>
          <Inp value={dur} onChange={e=>setDur(e.target.value.replace(/\D/g,''))} placeholder="45" inputMode="numeric" maxLength={4}/>
          <span style={{fontSize:13,color:'var(--g500)',flexShrink:0}}>min</span>
        </div>
        {dur&&Number(dur)>0&&<div style={{marginTop:6,fontSize:12.5,color:'var(--blue)',background:'var(--blue-l)',padding:'4px 10px',borderRadius:6,display:'inline-block'}}>{fmtDur(dur)}</div>}
      </Field>
    </Modal>
  );
}

export function Servicos(){
  const {servicos}=useStore();
  const [q,setQ]=useState('');const [modal,setModal]=useState(null);
  const list=servicos.filter(s=>s.nome?.toLowerCase().includes(q.toLowerCase()));
  const del=async id=>{if(window.confirm('Excluir?'))await store.deleteServico(id);};
  return(
    <div className={s.wrap}>
      <div className={s.bar}>
        <div className={s.srch}><Icons.Search/><input placeholder="Buscar serviço..." value={q} onChange={e=>setQ(e.target.value)}/></div>
        <div className={s.rgt}><span className={s.cnt}>{servicos.length} serviços</span><Btn icon={<Icons.Plus/>} onClick={()=>setModal({})}>Novo Serviço</Btn></div>
      </div>
      <div className={s.card}><div className={s.tw}>
        <table className={s.tb}>
          <thead><tr><th>Serviço</th><th>Duração</th><th>Preço</th><th>Ações</th></tr></thead>
          <tbody>
            {list.length===0&&<tr><td colSpan={4}><div className={s.emp}><Icons.Scissors/><p>{q?'Nenhum encontrado.':'Nenhum serviço cadastrado.'}</p>{!q&&<Btn size="sm" onClick={()=>setModal({})}>Cadastrar primeiro</Btn>}</div></td></tr>}
            {list.map(sv=>(
              <tr key={sv.id}>
                <td><strong style={{color:'var(--g800)'}}>{sv.nome}</strong></td>
                <td><span style={{background:'var(--g100)',color:'var(--g600)',borderRadius:20,padding:'3px 10px',fontSize:12,fontWeight:500}}>{fmtDur(sv.dur)}</span></td>
                <td><strong style={{color:'var(--green)'}}>{fmtP(sv.preco)}</strong></td>
                <td><div className={s.acts}><button className={s.ab} onClick={()=>setModal(sv)}><Icons.Edit/></button><button className={`${s.ab} ${s.abd}`} onClick={()=>del(sv.id)}><Icons.Trash/></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>
      {modal!==null&&<SvcModal initial={modal?.id?modal:null} onClose={()=>setModal(null)}/>}
    </div>
  );
}
